<template>
  <div class="myOrder">
    <orderDetail @backAndClose='backAndClose' v-if="orderDetailShow" :orderNo='orderNoDetail'></orderDetail>
    <div class="app-container calendar-list-container" v-else>
      <div class="title">订单中心</div>
        <el-divider></el-divider>
      <!-- 状态切换区 -->
      <div class="nav-box">
        <ul>
          <li :class="currentIndex=== 0 ?' active':''" @click="handleTab(0)">全部</li>
          <li :class="currentIndex=== 1 ? 'active':''" @click="handleTab(1)">已完成</li>
          <li :class="currentIndex=== 2 ? 'active':''" @click="handleTab(2)">待支付</li>
        </ul>
      </div>
      <el-form :model="listQuery" ref="form" class="search-form-inline" label-width="80px">
        <el-row :gutter="15">
          <el-col :span="5">
            <el-form-item label="订单编号" prop="orderNo">
              <el-input clearable v-model="listQuery.orderNo" placeholder="订单号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="出行人证件号" prop="visitorCertificateNo" label-width="100px">
              <el-input clearable v-model="listQuery.visitorCertificateNo" placeholder="出行人证件号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="联系人手机号" prop="contactMobile" label-width="100px">
              <el-input clearable v-model="listQuery.contactMobile" placeholder="联系人手机号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="出游日期" prop="orderTime">
              <el-date-picker clearable class="w50" v-model="listQuery.orderTime" type="daterange" range-separator="至" format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @change="flage++"
                    style="width:95%;"
                    >
              </el-date-picker>
              <input hidden :value="flage"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="mb20" style="text-align:center;">
          <el-button @click="getList" type="primary">查询</el-button>
          <el-button @click="reset('form')">重置</el-button>
        </el-row>
      </el-form>
      <el-table class="order-table" :default-expand-all='true' :key='tableKey' :data='list' v-loading.body='listLoading' fit highlight-current-row style='width: 100%'>
          <el-table-column class="s1" align='center' label='订单编号'>
              <template slot-scope='scope'>
                  <span>{{scope.row.orderNo}}</span>
              </template>
          </el-table-column>
          <el-table-column align='center' label='下单时间'>
              <template slot-scope='scope'>
                  <span>{{scope.row.orderTime}}</span>
              </template>
          </el-table-column>
          <el-table-column align='center' label='联系人手机号'>
              <template slot-scope='scope'>
                  <span>{{scope.row.contactMobile}}</span>
              </template>
          </el-table-column>
          <el-table-column align='center' label='订单状态'>
              <template slot-scope='scope'>
                  <span>{{scope.row.statusName}}</span>
              </template>
          </el-table-column>
          <el-table-column type="expand" label='展开所有' width="100">
          <template slot-scope="scope">
            <el-table  :show-header="true" :data="scope.row.tripOrderDetailDOList" style="width: 100%" fit border>
              <el-table-column align='center' prop="goodsName" label="产品名称"></el-table-column>
              <!-- <el-table-column align='center' prop="ticketKindName" label="票种"></el-table-column> -->
              <el-table-column align='center' prop="paymentTotal" label="支付金额" width='120'>
                <template slot-scope='subscope'>
                    <span>￥{{subscope.row.paymentTotal}}</span>
                </template>
              </el-table-column>
              <el-table-column align='center' prop="quantity" label="数量" width='100'></el-table-column>
              <el-table-column align='center' label='出游日期' width='200'>
                  <template slot-scope='subscope'>
                      <span>{{subscope.row.useStartDate.split(' ')[0]}}</span>
                  </template>
              </el-table-column>
              <!-- <el-table-column align='center' label='参观时段'>
                  <template slot-scope='subscope'>
                      <span>{{subscope.row.reservationBeginTime}} - {{subscope.row.reservationEndTime}}</span>
                  </template>
              </el-table-column> -->
              <el-table-column align='center' label="实付款/支付方式" width='140'>
                  <span>￥{{scope.row.paymentTotal}}</span>
                  <span v-if="scope.row.payTypeName">（{{scope.row.payTypeName}}）</span>
              </el-table-column>
              <el-table-column align='center' width='250' label="操作">
                  <span class='blue cursor pointer mr10' @click="hanleToDetail(scope.row.orderNo)">订单详情 </span>
                  <span class='blue cursor pointer mr10' v-if="scope.row.status === 28" @click="invoicDialogVisible = true">开具电子发票 </span>
                  <span class='blue cursor pointer mr10' v-if="scope.row.status === 10 || scope.row.status === 20" @click="hanleToRefund(scope.row.orderNo)"> 退款 </span>
                  <span class='blue cursor pointer mr10' v-if="scope.row.status === 0" @click="hanleTripCancel(scope.row.orderNo)"> 取消预约 </span>
                  <span class='blue cursor pointer mr10' v-if="scope.row.status === 0" @click="handleToPay(scope.row.uniteOrderNo)"> 立即支付 </span>
                  <!-- <span class='blue cursor pointer mr10' v-if="scope.row.status === 0" @click="hanleToPay(scope.row.orderNo,scope.row)">支付查询</span> -->
                  <!-- <span class='blue cursor pointer mr10' v-if="scope.row.status === '30' && scope.row.canRebook===true && isCanReBookFlag && isCanReBookFlag==='T'" @click="hanleToChageTicket(scope.row.orderNo)">改签 </span> -->
                  <!-- <span class='blue cursor pointer mr10' v-if="scope.row.status === '30'" @click="hanleToRefund(scope.row.orderNo)"> 退款</span>
                  <span class='blue cursor pointer' v-if="scope.row.status === '拒绝'" @click="hanleToReason(scope.row.remark)">查看原因</span>
                  <span class='blue cursor pointer' v-if="scope.row.status === '-2'&& isTravelLogin" @click="hanleReOrder(scope.row.orderNo)">重新下单</span> -->
              </el-table-column>
            </el-table>
            </template>
          </el-table-column>
      </el-table>
      <div v-show="!listLoading" class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="listQuery.page"
          :page-sizes="[10,20,30]"
          :page-size="listQuery.limit"
          layout="total, sizes, prev, pager, next, jumper"
          prev-text="上一页"
          next-text="下一页"
          :total="total"
        ></el-pagination>
      </div>
      <el-dialog class="refund-dialog" title="退款" :modal="false" left width="70%" :visible.sync="dialogCompVisible" :modal-append-to-body="false" :append-to-body="true">
          <el-table class="refund-table" header-row-class-name='parent-head-style' :key='tableKey' :data='tikcetInfoList' v-loading.body='listLoading' fit highlight-current-row @selection-change="handleSelectionChange" style='width: 100%'>
            <el-table-column type="selection" width="55" align="center"></el-table-column>
            <el-table-column align='center' label='票号'>
              <template slot-scope='scope'>
                <span>{{scope.row.ticketNo}}</span>
              </template>
            </el-table-column>
            <el-table-column align='center' label='产品名称'>
              <template slot-scope='scope'>
                <span>{{scope.row.goodsName}}</span>
              </template>
            </el-table-column>
            <el-table-column align='center' label='姓名'>
              <template slot-scope='scope'>
                <span>{{scope.row.visitorName}}</span>
              </template>
            </el-table-column>
            <el-table-column align='center' label='证件号'>
              <template slot-scope='scope'>
                <span>{{scope.row.visitorCertificateNo}}</span>
              </template>
            </el-table-column>
            <el-table-column align='center' label='价格'>
              <template slot-scope='scope'>
                <span>{{scope.row.unitPrice}}</span>
              </template>
            </el-table-column>
            <el-table-column align='center' label='手续费'>
              <template slot-scope='scope'>
                <span>{{scope.row.refundPoundage.toFixed(2)}}</span>
              </template>
            </el-table-column>
          </el-table>
          <div slot="footer" class="dialog-footer">
            <div class="travel-refundTotal">已选 {{selectionList.length}} 张，合计 <span class="red">￥{{refunfPrice}}</span>（扣除手续费￥{{refundPoundage}}）</div>
            <el-button v-loading.fullscreen.lock="fullscreenLoading" type="primary" @click="submitRefund">退款</el-button>
          </div>
      </el-dialog>
      <el-dialog title="改签" left width="70%" :visible.sync="dialogTicketVisible">
        <el-table header-row-class-name='parent-head-style' :key='tableKey' :data='tikcetOrderList' fit highlight-current-row @selection-change="handleSelectionTicketChange" style='width: 100%'>
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column align='center' label='票号'>
            <template slot-scope='scope'>
              <span>{{scope.row.ticketNo}}</span>
            </template>
          </el-table-column>
          <el-table-column align='center' label='产品名称'>
            <template slot-scope='scope'>
              <span>{{scope.row.ticketName}}</span>
            </template>
          </el-table-column>
          <el-table-column align='center' label='票种'>
            <template slot-scope='scope'>
              <span>{{scope.row.ticketKindName}}</span>
            </template>
          </el-table-column>
          <el-table-column align='center' label='状态'>
            <template slot-scope='scope'>
                <span v-if="scope.row.status === '-1'">{{'已关闭'}}</span>
                <span v-if="scope.row.status === '20'">{{'待检票'}}</span>
                <span v-if="scope.row.status === '10'">{{'待审核'}}</span>
                <span v-if="scope.row.status === '30'">{{'已出票'}}</span>
                <span v-if="scope.row.status === '50'">{{'已退款'}}</span>
                <span v-if="scope.row.status === '60'">{{'已完成'}}</span>
                <span v-if="scope.row.status === '40'">{{'部分退款'}}</span>
            </template>
          </el-table-column>
          <el-table-column align='center' label='姓名'>
            <template slot-scope='scope'>
              <span>{{scope.row.visitorName}}</span>
            </template>
          </el-table-column>
          <el-table-column align='center' label='证件号'>
            <template slot-scope='scope'>
              <span>{{scope.row.visitorCertificateNo}}</span>
            </template>
          </el-table-column>
          <el-table-column align='center' label='特殊证件'>
            <template slot-scope='scope'>
              <span>{{scope.row.specialCertificate}}</span>
            </template>
          </el-table-column>
          <el-table-column align='center' label='价格'>
            <template slot-scope='scope'>
              <span>{{scope.row.totalPrice}}</span>
            </template>
          </el-table-column>
          <el-table-column align='center' label='手续费'>
            <template slot-scope='scope'>
              <span>{{scope.row.refundPoundage}}</span>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitEndorse">改签</el-button>
        </div>
      </el-dialog>

      <el-dialog left width="70%" :visible.sync="dialogTimeVisible">
        <div class="div-ticket">
          <div class="buyticket-div">
            <span class="title">选择改签日期</span>
            <div class="buyticket-right">
              <div class="select-btn" style="margin: 0 7px">
                <span :class="valueDate?'picker-options active':'picker-options'">
                  <el-date-picker
                    :picker-options="pickerOptions"
                    v-model="valueDate"
                    format="MM月dd日"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="其他日期"
                    :editable="false"
                    :clearable="false"
                    @change="handleSaleDate"
                  ></el-date-picker>
                </span>
              </div>
              <div class="select-list">
                <span
                  @click="bindDateChange(item,index)"
                  v-for="(item,index) in date"
                  :key="index"
                >
                <template v-if="index<=2">
                  <em
                    v-if="item.showDate"
                    :class="[item.selectTime?'active':'' , item.canReservationSanke==='F'  ? 'disable' : '']"
                    style="line-height: 34px"
                  >{{item.showDate[1]}}月{{item.showDate[2]}}日</em>
                </template>
                </span>
              </div>
              <span
                v-show="!timeSharingSelect"
                class="time-select-text"
              >请选择日期和检票进场时段进行改签！</span>
            </div>
          </div>
          <div class="buyticket-div">
            <span class="title">选择检票进场时段</span>
            <div class="buyticket-right">
              <div class="select-list">
                <span
                  @click="radioChange(item)"
                  v-for="(item,index) in timeSharing"
                  :key="index"
                >
                  <em
                    :class="[item.isCheck?'active':'' , item.canReservationSanke === 'F' ? 'disable' : '']"
                  >
                    {{item.reservationBeginTime}}~{{item.reservationEndTime}}
                    <br />
                    余量：{{item.surplusStockNum}}
                  </em>
                </span>
              </div>
            </div>
          </div>
        </div>
          <div slot="footer" class="dialog-footer text-center">
            <el-button type="primary" @click="submitReBook">确认改签</el-button>
          </div>
      </el-dialog>
      <!-- 支付弹框 -->
      <payDialog ref="payDialog" />
      <!-- 开票弹窗 -->
      <el-dialog
        title=""
        customClass="invoicDialog"
        :visible.sync="invoicDialogVisible"
        :close-on-click-modal="false"
        :append-to-body="true"
        :modal-append-to-body="true"
      >
        <div class="title">请微信扫码填写发票信息</div>
        <div class="qrCode">
          <img class="img" src="@/assets/images/invoicing.png" alt="" />
        </div>
        <div class="footer-btn">
          <div @click="invoicDialogVisible = false">取消</div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { page, PayForTheQuery, findRebook, canReBook, isCanRebook } from '@/api/myOrder'
import { reservationDaily, getPreSaleDays, reservationConfig, standByList } from '@/api/buyTicket'
import { getTripTicketRefund, tripRefund, tripCancel } from '@/api/buyTicket_xqs'
import { dateFtt } from '../common/js/common'
import { config } from '@/constant/config'
import orderDetail from './orderDetail'
import PayDialog from '@/components/payDialog'

export default {
  name: 'orderList',
  data () {
    return {
      list: [],
      flage: 0,
      ticketInfo: {},
      total: null,
      listLoading: false,
      listQuery: {
        limit: 10,
        page: 1
      },
      tableKey: 0,
      dialogCompVisible: false,
      dialogTicketVisible: false,
      selectionList: [],
      selectionTicketList: [],
      tikcetOrderList: [],
      refunfPrice: 0,
      refundPoundage: 0,
      tikcetInfoList: [],
      date: [],
      isCanReBookFlag: null,
      valueDate: '',
      isTravelLogin: false,
      dialogTimeVisible: false,
      status: [],
      visitorCertificateNo: null,
      orderNo: null,
      customerList: null,
      timeSharing: [],
      selectDate: '',
      reOrderNo: null,
      orderNoDetail: null,
      orderDetailShow: false,
      timeSharingSelect: false,
      ReservationConfig: {},
      dateList: [],
      fullscreenLoading: false,
      pickerOptions: {
        disabledDate (time) {
          const curDate = (new Date()).getTime()
          // 这里算出一个月的毫秒数,
          const day = 14 * 24 * 3600 * 1000
          const bday = 2 * 24 * 3600 * 1000
          const dateRegion = curDate + day
          return time.getTime() < curDate + bday ||
          time.getTime() > dateRegion
        }
      },
      currentIndex: 0,
      invoicDialogVisible: false
    }
  },
  created () {
    this.getList()
  },
  computed: {},
  components: {
    orderDetail,
    'payDialog': PayDialog
  },
  methods: {
    handleToPay (orderNo) {
      this.$refs.payDialog.toPay(orderNo, 'TRIP')
    },
    // 获取普通产品列表
    getPreSaleDays () {
      return new Promise((resolve, reject) => {
        getPreSaleDays().then(res => {
          if (res.code === 0) {
            let value = res.data.value || 10
            // 如果是全角数字需要转换
            if (value.match(/[\uff00-\uffff]/g)) {
              value = this.CtoH(value)
            }
            resolve(parseInt(value) + 1)
          } else if (res.code === 1017) {
            this.$message({
              message: '登录过期，安全性提醒：请重新登录',
              type: 'error'
            })
          } else {
            this.$message({
              message: res.error,
              type: 'error'
            })
            resolve(10)
          }
        })
      })
    },
    getIsCanReBook () {
      isCanRebook().then(res => {
        if (res.code === 0) {
          this.isCanReBookFlag = res.data.value
        }
      })
    },
    getstaggeredList () {
      let data = {
        reservationDate: this.selectDate,
        orgId: sessionStorage.getItem('orgId')
      }
      reservationDaily(data).then(res => {
        if (res.code === 0) {
          let timeSharing = []
          let data = res.data
          if (data.length > 0) {
            let ids = data.findIndex(value => value.canReservationSanke === 'T')
            data.forEach((item, index) => {
              item.reservationMsg = item.reservationBeginTime + '~' + item.reservationEndTime
              if (index === ids) {
                // item.isCheck = true
              } else {
                item.isCheck = false
              }
            })

            // 过滤指定预约时段
            if (config.filterReservationDaily) {
              const filterReservationDaily = config.filterReservationDaily.split('-')
              if (config.isShowFilterReservationDaily) {
                data = data.filter(item => {
                  return (item.reservationBeginTime === filterReservationDaily[0] && item.reservationEndTime === filterReservationDaily[1])
                })
              } else {
                data = data.filter(item => {
                  return (item.reservationBeginTime !== filterReservationDaily[0] && item.reservationEndTime !== filterReservationDaily[1])
                })
              }
            }
            timeSharing = data
            this.timeSharingIndex = ids
            this.timeSharing = timeSharing
            this.date.forEach(item => {
              delete item.selectTime
              if (item.isCheck) {
                item.selectTime = this.timeSharing[this.timeSharingIndex]
              }
            })
            this.getSelectTime()
          } else {
            this.timeSharingIndex = null
            this.timeSharing = []
          }
        } else if (res.code === 1017) {
          this.$message({
            message: '登录过期，安全性提醒：请重新登录',
            type: 'error'
          })
        } else {
          this.$message({
            message: res.error,
            type: 'error'
          })
        }
      })
    },
    getSelectTime () {
      this.date.forEach(item => {
        if (item.isCheck) {
          this.selectTime = item.selectTime || {}
          this.selectTime.showDate = item.showDate
        }
      })
    },
    radioChange (data) {
      if (data.canReservationSanke === 'F') {
        this.$message({
          message: '该时段无预约票',
          type: 'error'
        })
        return false
      }
      this.timeSharing.forEach((item, index) => {
        item.isCheck = false
        if (item.id === data.id) {
          item.isCheck = true
          this.timeSharingIndex = index
          this.timeSharingSelect = true
        }
      })
    },
    // 日期框架选择日期
    handleSaleDate () {
      let selectDate = this.date.find(res => res.date === this.valueDate)
      if (!selectDate) {
        this.valueDate = this.selectDate
        this.date.forEach(i => {
          i.isCheck = false
          i.selectTime = false
        })
        this.$message({
          message: '该日期无预约票',
          type: 'error'
        })
        return false
      }
      if (selectDate.canReservationSanke === 'F') {
        let ids = this.date.findIndex((res, index) => (index <= 2 && res.date === this.valueDate))
        let idsi = this.date.findIndex((res, index) => index > 2 && res.date === this.selectDate)
        if (ids === -1) {
          this.valueDate = ''
        }
        if (idsi > -1) {
          this.valueDate = this.selectDate
        }
        this.$message({
          message: '该日期无预约票',
          type: 'error'
        })
        return false
      }
      this.date.forEach(i => {
        i.isCheck = false
        i.selectTime = false
      })
      this.timeSharingSelect = false
      this.selectDate = this.valueDate
      this.getstaggeredList()
    },
    // 日期点击选择
    bindDateChange (item, idx) {
      if (item.canReservationSanke === 'F') {
        this.$message({
          message: '该日期无预约票',
          type: 'error'
        })
        return false
      }
      this.date.forEach(i => {
        i.isCheck = false
        i.selectTime = false
        if (i.date === item.date) {
          i.isCheck = true
          i.selectTime = true
        }
      })
      if (item.date !== this.selectDate) {
        this.valueDate = ''
        this.selectDate = item.date
        this.ticketList = null
        this.timeSharingSelect = false
        this.getstaggeredList()
      }
    },
    // 改签
    hanleToChageTicket (orderNo) {
      this.$confirm('改签操作仅能发起一次，请确认是否改签', '提示', {
        showCancelButton: false,
        type: 'warning',
        confirmButtonText: '确定'
      }).then(() => {
        this.dialogTicketVisible = true
        const data = {
          orderNo
        }
        this.reOrderNo = orderNo
        findRebook(data).then(res => {
          if (res.code === 0) {
            this.tikcetOrderList = res.data
          } else {
            this.$message.error(res.error)
          }
        })
      })
    },
    handleSizeChange (value) {
      this.listQuery.limit = value
      this.listQuery.page = 1
      this.getList()
      console.log(value)
    },
    handleCurrentChange (value) {
      this.listQuery.page = value
      this.getList()
      console.log(value)
    },
    spanMethod ({ row, column, rowIndex, columnIndex }) {
      const len = this.list[row.fromSort].tripOrderDetailDOList.length
      if (columnIndex === 4 || columnIndex === 5) {
        if (rowIndex === 0) {
          return [len, 1]
        } else {
          return [0, 0]
        }
      }
    },
    getList () {
      // this.getIsCanReBook()
      const listQuery = {
        orderNo: this.listQuery.orderNo || null,
        page: this.listQuery.page,
        limit: this.listQuery.limit,
        useStartDate: this.listQuery.orderTime && this.listQuery.orderTime[0] ? (this.listQuery.orderTime[0] + ' 00:00:00') : null,
        useEndDate: this.listQuery.orderTime && this.listQuery.orderTime[1] ? (this.listQuery.orderTime[1] + ' 23:59:59') : null,
        visitorCertificateNo: this.listQuery.visitorCertificateNo || null,
        contactMobile: this.listQuery.contactMobile || null,
        status: this.listQuery.status || null

      }
      page(listQuery).then(response => {
        this.listLoading = false
        if (response.code === 0) {
          response.data.list.forEach(item => {
            let tripOrderDetailDOList = []
            tripOrderDetailDOList.push({
              goodsName: item.goodsName,
              paymentTotal: item.paymentTotal,
              quantity: item.quantity,
              payTypeName: item.payTypeName,
              useStartDate: item.useStartDate.split(' ')[0],
              useEndDate: item.useEndDate.split(' ')[0],

              orderNo: 1337393744726908929,
              contactCardNo: null,
              status: 36,
              unitPrice: 0.010000
            })
            item.tripOrderDetailDOList = tripOrderDetailDOList
          })
          this.list = response.data.list
          this.total = response.data.totalCount
        } else {
          this.$message.error('请求出错了')
        }
      })
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      let index = this.list.findIndex(item => item.orderNo === row.orderNo)
      let len = this.list[index].tripOrderDetailDOList.length
      if (columnIndex === 6 || columnIndex === 7) {
        if (rowIndex === 0) {
          return [len, 1]
        } else {
          return [0, 0]
        }
      }
    },
    handleTab (inx) {
      this.listQuery.page = 1
      this.currentIndex = inx
      switch (inx) {
        case 0:
          this.listQuery.status = null
          break
        case 1:
          this.listQuery.status = '28'
          break
        case 2:
          this.listQuery.status = '0'
          break
      }
      this.getList()
    },
    // 支付
    hanleToPay (orderNo, item) {
      // 支付
      this.$router.push({
        path: 'payOrder',
        query: {
          orderNo
        }
      })
    },
    hanleTripCancel (orderNo) {
      this.$confirm('取消预约, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        tripCancel({ orderNo }).then(res => {
          if (res.code === 0) {
            this.$message.success('取消成功')
            this.getList()
          } else {
            this.$message.error(res.error)
          }
        })
      })
    },
    // 退款
    hanleToRefund (orderNo) {
      this.visitorCertificateNo = null
      this.orderNo = orderNo
      this.ticketInfo = {}
      const data = {
        orderNo,
        isNeedPoundage: 'T',
        isSpecialReturn: 'F'
      }
      getTripTicketRefund(data).then(response => {
        if (response.code === 0) {
          this.ticketInfo = response.data
          if (this.ticketInfo) {
            this.tikcetInfoList = this.ticketInfo.tikcetInfoList.map(item => {
              for (const ot of this.status) {
                if (ot.code === item.status) {
                  item.status = ot.value
                  break
                }
              }
              return item
            })
            this.refunfPrice = 0
            this.refundPoundage = 0
            this.dialogCompVisible = true
          } else {
            this.$message.warning('暂无可退款的票')
          }
        } else {
          this.$message.error('请求出错了')
        }
      })
    },
    submitReBook () {
      const timeSharing = this.timeSharing.filter(val => val.isCheck === true)
      if (timeSharing.length === 0) {
        this.$message.warning('请选择检票进场时段')
        return false
      }
      const rebookTikcetDetails = []
      this.selectionTicketList.forEach(item => {
        rebookTikcetDetails.push({
          staggeredReservationDailyId: timeSharing[0].id,
          ticketNo: item.ticketNo,
          useStartDate: this.selectDate + ' 00:00:00'
        })
      })
      const data = {
        rebookTikcetDetails,
        orderNo: this.reOrderNo
      }
      canReBook(data).then(res => {
        if (res.code === 0) {
          this.$message.success('改签票成功')
          this.dialogTimeVisible = false
          this.selectionTicketList = []
          this.timeSharing = []
          this.getList()
        } else {
          this.$message.error(res.error)
        }
      })
    },
    submitEndorse () {
      if (this.selectionTicketList.length === 0) {
        this.$message.warning('请选择要改签的票')
        return false
      }
      this.dialogTicketVisible = false
      this.dialogTimeVisible = true
      const tempDate = new Date()
      const acquired = new Date()
      this.getPreSaleDays().then(res => {
        this.presaledays = res
        console.log(this.presaledays)
        if (this.presaledays) {
          var _this = this
          tempDate.setDate(tempDate.getDate())
          acquired.setDate(acquired.getDate() + this.presaledays)
          let date = [{
            title: dateFtt('MM-dd', tempDate),
            currentDate: false,
            postDate: dateFtt('yyyy-MM-dd', tempDate)
          }, {
            title: dateFtt('MM-dd', acquired),
            currentDate: false,
            postDate: dateFtt('yyyy-MM-dd', acquired)
          }]
          this.dateList = date
          this.pickerOptions = {
            disabledDate (time) {
              const curDate = (new Date()).getTime() - (1 * 24 * 3600 * 1000)
              // 这里算出一个月的毫秒数,
              const day = (_this.presaledays) * 24 * 3600 * 1000
              const dateRegion = curDate + day
              return time.getTime() < curDate || time.getTime() > dateRegion
            }
          }
          this.getReservationConfig()
        }
      })
    },
    /**
   * @description: 查询日期是否开始分时段预约，开启时继续查询当天全部时段数据，未开启分时段预约时直接查询当天可售列表数据
   */
    getReservationConfig () {
      const data = {
        orgId: sessionStorage.getItem('orgId')
      }
      reservationConfig(data).then(res => {
        if (res.code === 0) {
          this.ReservationConfig = res.data
          // 是否开启分时段预约
          if (res.data.isSaleStaggered === 'T') {
            // 查询预约余票量
            this.standByList()
          } else {
            this.timeSharingIndex = null
          }
        } else if (res.code === 1017) {
          this.$message({
            message: '登录过期，安全性提醒：请重新登录',
            type: 'error'
          })
        } else {
          this.$message({
            message: res.error,
            type: 'error'
          })
        }
      })
    },
    /**
     * @description: 查询固定时间余票量和是否停用
     */
    standByList () {
      console.log(this.dateList)
      const data = {
        orgId: sessionStorage.getItem('orgId'),
        beginDate: this.dateList[0].postDate,
        endDate: this.dateList[1].postDate
      }
      standByList(data).then(res => {
        if (res.code === 0) {
          let arr = []
          arr = res.data.sort(function (a, b) { return a.date > b.date ? 1 : -1 })
          arr.forEach((item, index) => {
            item.showDate = item.date.split('-')
          })
          let ids = res.data.findIndex((value) => (value.canReservationSanke === 'T'))
          if (ids > -1) {
            arr.forEach((item, index) => {
              if (index === ids) {
                item.isCheck = true
                this.selectDate = item.date
                if (ids >= 3) {
                  this.valueDate = item.date
                }
              } else {
                item.isCheck = false
              }
            })
            this.getstaggeredList()
          }
          this.date = arr
        } else if (res.code === 1017) {
          this.$message({
            message: '登录过期，安全性提醒：请重新登录',
            type: 'error'
          })
        } else {
          this.$message({
            message: res.error,
            type: 'error'
          })
        }
      })
    },
    submitRefund () {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择要退款的票')
        return
      }
      const refundTikcetDetails = this.selectionList.map(item => ({
        poundAge: item.refundPoundage,
        ticketNo: item.ticketNo
      }))
      const data = {
        originalOrderNo: this.ticketInfo.tripOrderForRefundVO.orderNo,
        outRefundOrderNo: this.ticketInfo.tripOrderForRefundVO.outOrderNo,
        isNeedPoundage: 'T',
        isSpecialReturn: 'F',
        refundTikcetDetails
      }
      this.fullscreenLoading = true
      tripRefund(data).then(res => {
        this.dialogCompVisible = false
        this.fullscreenLoading = false
        if (res.code === 0) {
          this.$message.success('申请成功')
          this.getList()
        } else {
          this.$message.error(res.error)
        }
      })
    },
    handleSelectionChange (val) {
      this.selectionList = val
      if (this.selectionList.length !== 0) {
        let refunfPrice = 0
        let refundPoundage = 0
        this.selectionList.forEach(item => {
          refunfPrice += Number(item.unitPrice)
          refundPoundage += Number(item.refundPoundage)
        })
        this.refundPoundage = refundPoundage.toFixed(2)
        this.refunfPrice = (refunfPrice - refundPoundage).toFixed(2)
      }
    },
    handleSelectionTicketChange (val) {
      this.selectionTicketList = val
    },
    // 查看审核失败原因
    hanleToReason (msg) {
      this.$alert(msg, '审核失败原因', {
        confirmButtonText: '确定'
      })
    },
    // 订单详情
    hanleToDetail (orderNo) {
      this.orderNoDetail = orderNo
      this.orderDetailShow = true
    },
    toPath (path) {
      console.log(path)
      this.$router.push(path)
    },
    reset (name) {
      this.$refs[name].resetFields()
      this.currentIndex = 0
      this.listQuery = {
        limit: 10,
        page: 1
      }
    },
    tempObj () {
      const data = {
        orderTimeEnd:
          this.listQuery.orderTime && this.listQuery.orderTime.length > 0
            ? this.listQuery.orderTime[1]
            : null,
        orderTimeStart:
          this.listQuery.orderTime && this.listQuery.orderTime.length > 0
            ? this.listQuery.orderTime[0]
            : null,
        orderNo: this.listQuery.orderNo || null,
        contactCertificateNo: this.listQuery.contactCertificateNo || null,
        contactMobile: this.listQuery.contactMobile || null,
        tripCertificateNo: this.listQuery.tripCertificateNo
      }
      return data
    },
    handleReset (formName) {
      this.$refs[formName].resetFields()
    },
    hanleReOrder (orderNo) {
      this.$router.push({
        path: 'productBook',
        query: {
          orderNo
        }
      })
    },
    handleTikcetInfoListFilter () {
      if (!this.visitorCertificateNo.trim()) {
        this.hanleToRefund(this.orderNo)
        return
      }
      const tikcetInfoList = this.tikcetInfoList.filter(item => item.visitorCertificateNo === this.visitorCertificateNo.trim())
      this.tikcetInfoList = tikcetInfoList
    },
    backAndClose () {
      this.orderDetailShow = false
    },
    payQuery (orderNo) {
      PayForTheQuery(orderNo).then(res => {
        console.log(res)
        if (res.code === 0) {
          if (res.data === 'UNPAID') {
            this.$confirm('订单未支付或者系统异常', '支付查询', {
              showCancelButton: false,
              confirmButtonText: '确定'
            })
            return
          }
          if (res.data === 'PAID') {
            this.$confirm('出票成功', '支付查询', {
              showCancelButton: false,
              confirmButtonText: '确定'
            })
            return
          }
          this.$confirm(res.error, '支付查询', {
            showCancelButton: false,
            confirmButtonText: '确定'
          })
        }
      })
    }
  }
}
</script>
<style lang="scss">
.invoicDialog{
  width: 440px;
  background: #FFFFFF;
  box-shadow: 0px 3px 6px rgba(14, 78, 114, 0.08);
  opacity: 1;
  border-radius: 16px;
  .title{
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    line-height: 21px;
    color: #A0393E;
    text-align: center;
    margin-bottom: 48px;
  }
  .qrCode{
    padding: 0;
    .img{
      width: 256px;
      height: 256px;
    }
  }
  .footer-btn{
    width: 340px;
    height: 44px;
    background: #A0393E;
    opacity: 1;
    border-radius: 4px;
    font-size: 16px;
    font-weight: bold;
    line-height: 44px;
    color: #FFFFFF;
    text-align: center;
    margin: 48px auto 10px auto;
  }
}
.myOrder{
  // width: 70%;
  background: white;
  margin: 0 auto;
  padding: 40px 20px;
  // min-width: 1230px;
  /deep/.el-button--primary, .el-button--primary:hover {
    background-color: #9B232A;
    border-color: #9B232A;
  }
  /deep/.el-button--default:hover {
    background-color: #FFF;
    border-color: #DCDFE6;
    color: #606266;
  }
}
.order-table{
    .el-table__header-wrapper{
        thead {
            th{
                color: #3d3d3d;
                font-weight: bold;
                // background: red;
            }
        }
    }
    .el-table__body-wrapper{
        .el-table__row{
            background: #F1F6FF;
        }
        .el-table__expanded-cell{
            padding: 0;
            thead {
              th{
                color: #3d3d3d;
              }
            }
            .el-table__row{
              background: #fff;
            }
        }
        .el-table--enable-row-hover .el-table__body tr:hover>td{
            background: #fff;
        }
    }
}
.travel-refundTotal{
  position: absolute;
  bottom: 20px;
  left: 25%;
  right: 25%;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  color: #666;
}
.calendar-list-container{
  margin: 0 auto;
  .title {
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #9B232A;
  }
  .tab-box {
    overflow: hidden;
    margin-bottom: 10px;
    background: #F1F6FF;
  .back {
    float: right;
    border-radius: 6px;
  }
  span {
    float: left;
    width: 130px;
    height: 44px;
    cursor: pointer;
    color: #8791A5;
    font-size: 16px;
    margin-right: 2px;
    text-align: center;
    line-height: 44px;
    &.active {
      border-bottom: 2px solid #3987E1;
      color: #3987E1;
    }
  }
}
}
.mr10 {
  margin-right: 10px;
}
.cursor{
  cursor: pointer;
}
.div-ticket {
  overflow: hidden;
  .buyticket-div {
    overflow: hidden;
    margin-bottom: 19px;
    .title {
      float: left;
      font-size: 16px;
      color: #333;
      font-weight: bold;
      line-height: 44px;
      height: 44px;
    }
    .buyticket-right {
      overflow: hidden;
      padding-left: 100px;
      // height: 44px;
      .select-list {
        float: right;
        text-align: right;
        > span {
          display: inline-block;
          margin: 0 7px;
          width: 130px;
          min-height: 44px;
          border-radius: 6px;
          font-size: 16px;
          color: #333;
          text-align: center;
          line-height: 44px;
          cursor: pointer;
          margin-bottom: 10px;
          > em {
            display: inline-block;
            width: 100%;
            height: 100%;
            line-height: 26px;
            border-radius: 6px;
            overflow: hidden;
            font-style: normal;
            background: rgba(246, 246, 246, 1);
            padding: 6px 0;
            &:hover {
              opacity: 0.8;
            }
            &.active {
              background: #241008;
              color: #fff;
            }
            &.disable {
              color: #cdcdcd;
              cursor: no-drop;
            }
          }
        }
      }
      .time-select-text {
        line-height: 44px;
        color: #ec2f2f;
      }
      .select-btn {
        float: right;
        width: 130px;
        height: 44px;
        line-height: 44px;
        border-radius: 6px;
        .input-show {
          display: block;
          width: 100%;
          height: 100%;
          line-height: 44px;
          text-align: center;
          height: 44px;
          background: #f6f6f6;
          border-radius: 6px;
          font-size: 16px;
          color: #333;
          text-align: center;
          line-height: 44px;
          cursor: pointer;
          outline: none;
          text-align: center;
          &.active {
            background: #241008;
            color: #fff;
          }
          &:hover {
            opacity: 0.8;
          }
        }
        .picker-options {
          display: block;
          width: 100%;
          height: 44px;
          line-height: 44px;
          .el-input {
            width: 100% !important;
            background: #f6f6f6;
          }
        }
      }
      .buyticket-list {
      }
    }
  }
  .buyticket-footer {
    overflow: hidden;
    display: flex;
    border-top: 1px solid #f6f6f6;
    padding-top: 29px;
    margin-top: 31px;
    .booking-notice {
      flex: 1;
      height: 58px;
      line-height: 58px;
      img {
        display: inline-block;
        width: 16px;
        height: 16px;
        vertical-align: middle;
        margin-right: 4px;
        cursor: pointer;
      }
      span {
        display: inline-block;
        font-size: 16px;
        color: #ec2f2f;
        vertical-align: middle;
        cursor: pointer;
      }
    }
    .booking-msg {
      flex: 1;
      overflow: hidden;
      line-height: 58px;
      text-align: right;
      .msg {
        display: inline-block;
        vertical-align: middle;
        font-size: 16px;
        color: #333;
        span {
          display: inline-block;
          color: #ff4400;
          margin: 0 12px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.order-table,.refund-table {
  >.el-table__header-wrapper tr th {
    background-color: #9B232A !important;
    color: #fff;
  }
}
.refund-dialog {
  .el-button--primary, .el-button--primary:hover {
    background-color: #9B232A;
    border-color: #9B232A;
  }
  .el-button--default:hover {
    background-color: #FFF;
    border-color: #DCDFE6;
    color: #606266;
  }
}
</style>
